import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import HeroSection from "../components/HeroSection";
import RealImpactSection from "../components/RealImpactSection";
import OpportunitiesSection from "../components/OpportunitiesSection";
import ApproachSection from "../components/ApproachSection";
import IndustriesSection from "../components/IndustriesSection";
import TomorrowSection from "../components/TomorrowSection";
import CtaSection from "../components/CtaSection";

const Home = () => {
  return (
    <div className="min-h-screen w-full bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <RealImpactSection />
        <OpportunitiesSection />
        <ApproachSection />
        <IndustriesSection />
        <TomorrowSection />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
